import { Col, Grid, Row } from 'antd';
import { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { HorizonalTabs } from '../../../shared/horizontal-tabs';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { PaymentContainer } from '../components/payment.container';
import { Helmet } from 'react-helmet';

interface SettingsProps {}

export const Settings: React.FC<SettingsProps> = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);

  const pages = [
    {
      id: '1',
      path: 'payment',
      title: 'Payment',
      icon: undefined
    }
  ];

  const routes: RouteDefinition[] = [{ id: '1', path: 'payment', element: <PaymentContainer /> }];

  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>
      {isMobile ? (
        <Col style={{ boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.2)', padding: '10px', minHeight: '100vh' }}>
          <Row style={{ marginTop: '-80px' }}>
            <HorizonalTabs routes={routes} menuItems={configPageNavigationMenu} />
          </Row>
        </Col>
      ) : (
        <div
          style={{
            marginLeft: '33px',
            marginTop: '33px',
            minHeight: '100vh',
            minWidth: '75vw'
          }}
        >
          <VerticalTabs routes={routes} menuItems={configPageNavigationMenu} />
        </div>
      )}
    </>
  );
};
